module.exports = __webpack_public_path__ + "media/newstyle/images/format_align_justify-8d52bf8d0358c943874b3e83db6cd5dd.svg";